import React, { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import StyledMenu from "../../../../components/layout/StyledMenu";
import { postNotification } from "../../../../components/utilities/Notifications";
import ModalLoadingMessage from "../../../../components/modals/ModalLoadingMessage";
import {
  getData,
  postData
} from "../../../../components/utilities/UtilityFunctions";
import {
  BCPUserMagnifyingGlass,
  BCPXmark
} from "../../../../components/icons/bcp/BCPIcons";
import { Formik } from "formik";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";

export function AdminOptionsMenu(props) {
  const { anchorEl, setAnchorEl, event, setEvent, authContext } = props;

  const [changeOwnershipModal, setChangeOwnershipModal] = useState(false);

  const [processing, setProcessing] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);

  const open = Boolean(anchorEl);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button"
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setChangeOwnershipModal(true);
            setAnchorEl(null);
          }}
          disableRipple
        >
          Change Ownership
        </MenuItem>
      </StyledMenu>

      {authContext?.authState?.identity?.isAdmin === true && (
        <ChangeOwnershipModal
          open={changeOwnershipModal}
          setOpen={setChangeOwnershipModal}
          event={event}
          setEvent={setEvent}
          setProcessing={setProcessing}
          setLoadingMessage={setLoadingMessage}
        />
      )}
      {loadingMessage && (
        <ModalLoadingMessage
          open={Boolean(loadingMessage)}
          message={loadingMessage}
        />
      )}
      {processing && <ModalLoadingFull />}
    </>
  );
}

export function ChangeOwnershipModal(props) {
  const {
    open,
    setOpen,
    event,
    // setEvent,
    setProcessing
  } = props;

  const confirm = useConfirm();

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2">
              Change Event Ownership
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            email: "",
            userId: "",
            firstName: "",
            lastName: ""
          }}
          enableReinitialize
          onSubmit={async (values) => {
            try {
              setProcessing(true);
              try {
                await confirm({
                  title: `Change Ownership.`,
                  description: `Are you sure you want to set ${`${
                    values.firstName || ""
                  } ${
                    values.lastName || ""
                  }`.trim()} as the new owner of this event?`,
                  dialogProps: {
                    sx: {
                      zIndex: 99999
                    }
                  }
                });
              } catch {
                setProcessing(false);
                return;
              }

              const body = {
                userId: values.userId
              };

              // const apiData =
              await postData(`/events/${event.id}/changeOwnership`, {
                body
              });

              postNotification(
                "success",
                `Event ownership has been successfully transferred.`
              );

              // TODO: /changeOwnership endpoint should return the updated event new owner. Currently it only returns an empty object.
              // setEvent(apiData);

              return;
            } catch (err) {
              postNotification("error", err);
            } finally {
              setProcessing(false);
              setOpen(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    name="email"
                    label="Email"
                    required
                    value={values.email}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onBlur={async (e) => {
                      if (e.target.value !== "") {
                        setProcessing(true);
                        try {
                          var apiUser = await getData(
                            `/users/${e.target.value}`,
                            {
                              queryStringParameters: {}
                            }
                          );
                          if (apiUser) {
                            if (apiUser.id === event.ownerId) {
                              postNotification(
                                "warning",
                                "User is already the event owner"
                              );
                            } else {
                              setFieldValue("userId", apiUser.id);
                            }
                            setFieldValue("firstName", apiUser.firstName);
                            setFieldValue("lastName", apiUser.lastName);
                          } else {
                            throw new Error("User not found");
                          }
                        } catch (err) {
                          setFieldValue("userId", "");
                          setFieldValue("firstName", "");
                          setFieldValue("lastName", "");
                          postNotification("warning", "User not found");
                        }
                        setProcessing(false);
                      }
                    }}
                    onChange={(e) => {
                      setFieldValue("userId", "");
                      setFieldValue("firstName", "");
                      setFieldValue("lastName", "");
                      handleChange(e);
                    }}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Search"
                            edge="end"
                            color="primary"
                            onClick={(e) => {}}
                          >
                            <BCPUserMagnifyingGlass />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="firstName"
                    label="First Name"
                    value={values.firstName}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="lastName"
                    label="Last Name"
                    value={values.lastName}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    disabled
                  />
                </Grid>

                <Grid item xs={6}>
                  <Button
                    color="error"
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="success"
                    type="submit"
                    disabled={!values.userId}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
